import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RFQsList from './RFQsList';
import RFQView from './RFQView';
import RFQEdit from './RFQEdit';

function RFQs() { 
  return (
    <Routes>
      <Route index element={<RFQsList type="regular" />} />  
      <Route path=":rfqId" element={<RFQView />} /> 
      <Route path=":rfqId/edit" element={<RFQEdit />} />
    </Routes>
  );
}

export default RFQs;
